import * as React from 'react';
import classnames from 'classnames';

const Container = ({ children , className  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('container', className)
    }, children)
;
var Container$1 = Container;

export { Container$1 as default };
//# sourceMappingURL=Container.js.map
